<template>
    <v-card class="p-4">
        <v-card-title class="text-lg font-medium">
            Adauga Client
        </v-card-title>
        <v-form ref="addLeadForm" v-model="validLeadForm" @submit.prevent="addNewLead">
            <div class="grid grid-cols-2 gap-4">
                <div class="flex flex-row justify-start gap-1">
                    <v-text-field ref="cuiField" v-model="lead.cui" label="CUI" type="text" hint="RO123456 sau 123456"
                        outlined dense :rules="[rules.required, rules.cui]"></v-text-field>
                    <v-btn class="teal lighten-2" text dark :loading="loadingCompanyDetails"
                        @click="getCompanyData">Cauta</v-btn>
                </div>
                <v-text-field label="Reg Com" text outlined dense :rules="[rules.required]"
                    v-model="lead.regCom"></v-text-field>
            </div>
            <div class="grid grid-cols-6 gap-x-4">
                <v-text-field label="Denumire" type="text" class="col-span-4" outlined dense :rules="[rules.required]"
                    v-model="lead.name"></v-text-field>
                <v-autocomplete v-model="lead.county" class="col-span-2" :loading="loadingCounties" :items="counties"
                    item-text="name" item-value="id_county" label="Alege judet" dense hide-details
                    outlined></v-autocomplete>
                <v-text-field label="Email" type="email" class="col-span-3" outlined dense
                    :rules="[rules.required, rules.email]" v-model="lead.email"></v-text-field>
                <v-text-field label="Telefon" type="tel" class="col-span-3" outlined dense
                    :rules="[rules.required, rules.phone]" v-model="lead.tel"></v-text-field>
            </div>
            <v-divider class="my-4"></v-divider>
            <v-alert v-if="existingLead.length" type="warning">Prospectul <span class="font-bold">{{
                existingLead[0].nume
                    }}</span> exista
                deja la <span class="font-bold">{{ existingLead[0].username }}</span></v-alert>
            <div v-else class="grid grid-cols-2 gap-x-4">
                <!-- <v-text-field label="Cifră afaceri an precendent" outlined :value="formattedTurnover"
                    @input="onTurnoverInput" suffix="RON" hide-spin-buttons></v-text-field> -->
                <v-select label="Cifră afaceri an precendent" outlined v-model="lead.turnover" :items="turnoverOptions"
                    item-text="text" item-value="value" suffix="RON" :rules="[rules.required]"></v-select>
                <v-select label="Profit net an precedent" outlined v-model="lead.netProfit" :items="profitOptions"
                    item-text="text" item-value="value" suffix="RON" :rules="[rules.required]"></v-select>
                <v-select label="Domeniu de activitate" outlined v-model="lead.activityField" :items="activityFields"
                    item-text="text" item-value="value" :rules="[rules.required]"></v-select>
                <!-- <v-text-field label="Nr. angajati" type="number" min="0" outlined
                    v-model.number="lead.employees"></v-text-field> -->
                <v-select label="Nr. angajati" outlined v-model="lead.employees" :items="employeeOptions"
                    item-text="text" item-value="value" suffix="angajati" :rules="[rules.required]"></v-select>
            </div>
            <div class="flex flex-row justify-end gap-2 mt-4">
                <v-btn color="blue-grey white-text" class="uppercase" large @click="closeModal">Anuleaza</v-btn>
                <v-btn color="teal white-text" class="uppercase" large :disabled="!!existingLead.length"
                    type="submit">Salveaza</v-btn>
            </div>
        </v-form>
        <!-- <pre>
            Lead: {{ lead }}
        </pre> -->
    </v-card>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import { getFormattedAddressFromAnaf, normalizeCountyName } from '@/utils';

export default {
    props: {
        user: Object
    },
    data() {
        return {
            loading: false,
            validLeadForm: false,
            existingLead: [],
            lead: {
                name: null,
                cui: null,
                regCom: null,
                address: null,
                turnover: null,
                netProfit: null,
                employees: null,
                activityField: null,
                county: null,
                email: null,
                phone: null,
            },
            rules: {
                // required: value => !!value || 'Câmp obligatoriu',
                required: value => value !== null && value !== undefined && value !== '' || 'Câmp obligatoriu',
                cui: value => !value || /^(RO)?[0-9]{2,9}$/.test(value) || 'CUI/CIF invalid',
                regcom: value => !value || /^([J|j]|[F|f]|[C|c])[0-9]{2}\/[0-9]+\/(19|20)([0-9]{2})$/.test(value) || 'Număr înregistrare incorect',
                email: value => !value || /.+@.+\..+/.test(value) || "Adresa email invalida",
                isEmailOrPhone: () => this.isEmailOrPhone || "Email sau telefon obligatoriu",
                phone: value => !value || /(\(?\+?\d{1,4}\)?\s?)?\d{6,12}/.test(value) || "Număr incorect",
            }
        }
    },
    computed: {
        ...mapState('contacts', ['loadingCompanyDetails']),
        ...mapState('zones', ["loadingCounties", "counties"]),
        ...mapState('salesLeads', ['loadingCheckLeadCui', 'loadingAddLead', 'turnoverOptions', 'profitOptions', 'activityFields', 'employeeOptions']),
        isEmailOrPhone() {
            return !!this.lead.phone || !!this.lead.email
        },
        formattedTurnover() {
            if (this.lead.turnover === null || this.lead.turnover === '') return '';
            return this.lead.turnover.toLocaleString('ro-RO');
        },
        formattedProfit() {
            if (this.lead.netProfit === null || this.lead.netProfit === '') return '';
            return this.lead.netProfit.toLocaleString('ro-RO');
        }
    },
    methods: {
        // helpers
        getFormattedAddressFromAnaf,
        normalizeCountyName,
        // actions
        ...mapActions('contacts', ['fetchCompanyDetailsFromAnaf', 'addContact']),
        ...mapActions('zones', ["fetchCounties"]),
        ...mapActions('salesLeads', ["checkLeadCui", "addLead"]),
        // local
        getNumeriValue(value) {
            // Remove non-digit characters before converting back to number
            const numericValue = parseFloat(
                value.toString().replace(/[^\d]/g, '')
            );
            return isNaN(numericValue) ? null : numericValue;
        },
        onTurnoverInput(value) {
            this.lead.turnover = this.getNumeriValue(value);
        },
        onProfitInput(value) {
            this.lead.netProfit = this.getNumeriValue(value);
        },
        async getCompanyData() {
            // check if cui is valid format
            const validCUI = await this.$refs.cuiField.validate();

            if (validCUI) {
                let cui = this.lead.cui
                cui = cui.replace(/\D/g, "");
                if (cui.length < 2 || cui.length > 9) {
                    alert("CUI/CIF trebuie sa aiba intre 2 si 9 cifre!");
                    return;
                }

                this.existingLead = await this.checkLeadCui(cui);

                if (this.existingLead.length === 0) {
                    const companyDetails = await this.fetchCompanyDetailsFromAnaf(cui);

                    if (companyDetails === undefined) {
                        alert('Nu au fost gasite date!')
                    } else {
                        this.lead.name = companyDetails.date_generale.denumire;
                        this.lead.regCom = companyDetails.date_generale.nrRegCom;
                        this.lead.cui = `${companyDetails.inregistrare_scop_Tva.scpTVA ? 'RO' : ''}${companyDetails.date_generale.cui}`
                        this.lead.address = this.getFormattedAddressFromAnaf(companyDetails.adresa_sediu_social);
                        this.lead.county = this.getCountyId(companyDetails.adresa_sediu_social.sdenumire_Judet)
                        this.lead.email = null;
                        this.lead.phone = null;
                    }
                } else {
                    console.log("Lead already exists:", this.existingLead[0]);
                    this.lead.name = this.existingLead[0].nume;
                    this.lead.regCom = this.existingLead[0].regCom;
                    this.lead.cui = this.existingLead[0].cui;
                    this.lead.address = this.existingLead[0].address;
                    this.lead.county = this.existingLead[0].county ? this.getCountyId(this.existingLead[0].county) : null;
                    this.lead.email = this.existingLead[0].email;
                    this.lead.phone = this.existingLead[0].phone;
                }
            } else {
                alert("verificati CUI/CIF!");
            }
        },
        getCountyId(countyStr) {
            const countyName = this.normalizeCountyName(countyStr);
            const county = this.counties.find(c => c.name === countyName);
            if (county) {
                return county.id_county;
            } else {
                alert(`Judetul ${countyName} nu a fost gasit!`);
                return null;
            }
        },
        closeModal() {
            this.lead = {
                name: null,
                cui: null,
                regCom: null,
                address: null,
                turnover: null,
                netProfit: null,
                employees: null,
                activityField: null,
                county: null,
                email: null,
                phone: null,
            }
            this.$refs.addLeadForm.resetValidation();
            this.$emit('closeModal')
        },
        async addNewLead() {
            const valid = await this.$refs.addLeadForm.validate();

            if (valid) {

                const newContact = {
                    firma: 1,
                    name: this.lead.name,
                    cui: this.lead.cui,
                    regCom: this.lead.regCom,
                    address: this.lead.address,
                    county: this.lead.county ? this.counties.find(c => c.id_county === this.lead.county).name : null,
                    email: this.lead.email,
                    phone: this.lead.phone,
                    agent: this.user.id_user
                };

                const contactId = await this.addContact(newContact)

                const newLead = {
                    createdAt: new Date().toISOString().substring(0, 10),
                    name: this.lead.name,
                    clientId: contactId.id_client,
                    userId: this.user.id_user,
                    userName: this.user.username,
                    turnover: this.lead.turnover,
                    net_profit: this.lead.netProfit,
                    employees: this.lead.employees,
                    activity_field: this.lead.activityField,
                };

                await this.addLead(newLead)
                this.closeModal()
            }
        }
    },
    created() {
        this.fetchCounties('ro');
    },
    destroyed() {
        this.existingLead = null; // Reset existing lead when component is destroyed
    }
}
</script>